const imageElements = (state = [], action) => {
  switch (action.type) {
    case 'ADD_ELEMENT':
      return [
        ...state,
        {
          id: action.id,
          url: action.url,
          code: action.code
        }
      ]
    case 'DEL_ELEMENT':
      return state.filter(element => element.id !== action.id);
    case 'DEL_ALL':
      return [];
    case 'GET_ALL':
      return state;
    default:
      return state;
  }
}

export default imageElements;


// WEBPACK FOOTER //
// ./src/reducers/imgElement.reducer.js